const currentTime = () => {
    let date = new Date()

    let hours = date.getHours()
    let mins = date.getMinutes()


    if (hours < 10){
        mins = `0${mins}`
    }
    if (mins < 10){
        mins = `0${mins}`
    }

    return `${hours}:${mins}:00`

}
export {currentTime}